module.exports = __webpack_public_path__ + "static/EmilyIsAway3-917465f1472c23d6bb22d4b169ef88a6.png";